/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2024 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState, useEffect, useRef } from 'react'
import Image from './components/Image'
import BoxEmptyImage from './components/BoxEmptyImage'
import SelectImageInput from './components/SelectImageInput'

const InputImage = ({
  imageUrl = '',
  onChange = () => {},
  onRemove = () => {},
  name,
  className
}) => {
  const [previewUrl, setPreviewUrl] = useState(imageUrl)
  const fileInputRef = useRef(null)

  useEffect(() => {
    setPreviewUrl(imageUrl)
  }, [imageUrl])

  const handleImageChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = () => {
        setPreviewUrl(reader.result)
        onChange(file)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleRemoveImage = () => {
    setPreviewUrl('')
    onChange(null)
    onRemove()
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const triggerFileInput = () => {
    fileInputRef.current?.click()
  }

  return (
    <div className={`flex flex-col items-center gap-4 ${className}`}>
      <div
        className="relative w-64 h-64 border-2 border-dashed border-gray-300 rounded-lg overflow-hidden flex items-center justify-center bg-gray-50"
        onClick={ !previewUrl ? triggerFileInput : undefined }
        style={{ cursor: !previewUrl ? 'pointer' : 'default' }}
      >
        { previewUrl
          ? <Image previewUrl={previewUrl} onRemove={handleRemoveImage} />
          : <BoxEmptyImage />
        }
      </div>
      <SelectImageInput
        triggerFileInput={triggerFileInput}
        fileInputRef={fileInputRef}
        onChangeImage={handleImageChange}
        inputName={name}
      />
    </div>
  )
}

export default InputImage
